import React, { useEffect } from 'react';
import { Link, animateScroll as scroll } from 'react-scroll';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { serviceContentList } from '../../axios/axios';
import { Accordion, Row, Col } from 'react-bootstrap';
import img1 from '../../assets/weo_1.svg';
import img2 from '../../assets/weo_2.svg';
import img3 from '../../assets/weo_3.svg';
import img4 from '../../assets/woe_4.svg';

function Tabs() {
	const [data, setData] = useState([]);
	const [activeTab, setActiveTab] = useState('active');

	let serviceContentApi;

	var activeClass = 0;

	const { id } = useParams();

	const dataContent = async () => {
		await serviceContentList({ id }).then((res) => setData(res.data));
		serviceContentApi(false);
	};

	let myID = document.getElementById('tab_scroll');

	var myScrollFunc = function () {
		var y = window.scrollY;
		if (y <= 1350) {
			setActiveTab('active');
		} else {
			setActiveTab('');
		}
	};

	window.addEventListener('scroll', myScrollFunc);

	useEffect(() => {
		dataContent();

		return () => {
			serviceContentApi = true;
		};
	}, [id]);

	return (
		<div className='fade_in'>
			<ul className='navigation py-3'>
				{data?.overview_content_active?.map((res, i) => {
					activeClass++;
					return (
						<li
							key={i}
							className='me-lg-2 me-md-3 tab_scroll_head'
							style={{ cursor: 'pointer' }}>
							<Link
								activeClass='active'
								className={activeClass == 1 ? activeTab : ''}
								id='tab_scroll'
								to={res.overview_menu.overview_alt_name}
								spy={true}
								smooth={true}
								offset={-140}
								duration={500}
								title={res.overview_menu.overview_alt_name}>
								{res.overview_menu.overview_alt_name}
							</Link>
						</li>
					);
				})}
				<li
					className='me-lg-2 me-md-3 tab_scroll_head'
					style={{ cursor: 'pointer' }}>
					<Link
						activeClass='active'
						id='tab_scroll'
						to='wao'
						spy={true}
						smooth={true}
						offset={-140}
						duration={500}
						title='Why eAuditor Office?'>
						Why eAuditor Office?
					</Link>
				</li>
				{data?.faqs_title_active !== null && (
					<li
						className='me-lg-2 me-md-3 tab_scroll_head'
						style={{ cursor: 'pointer' }}>
						<Link
							activeClass='active'
							id='tab_scroll'
							to='faq'
							spy={true}
							smooth={true}
							offset={-140}
							duration={500}
							title='FAQ'>
							FAQ
						</Link>
					</li>
				)}
			</ul>
			{data?.overview_content_active?.map((res, i) => {
				return (
					<div
						key={i}
						className='text-start mt-3 '
						id={res.overview_menu.overview_alt_name}>
						<p className='sc_tab_head'>{res.content_title}</p>
						<div className='eaudit-service-details'>
							<div
								className='tabContent'
								dangerouslySetInnerHTML={{ __html: res.content }}
							/>
						</div>
					</div>
				);
			}, [])}
			<div id='wao'>
				{' '}
				<p className='sc_tab_head text-start my-4 mt-md-5'>
					Why eAuditor Office?
				</p>
				<div className='mt-4 mt-md-5'>
					<div className='d-flex text-start align-items-center '>
						<img src={img1} alt='icon' title='icon' />
						<div className=' ms-4'>
							<p className='weo_head mb-0'>Cost Efficient</p>
							<p className='weo_sub_head mb-0'>registration process</p>
						</div>
					</div>
				</div>
				<div className='mt-4 mt-md-5'>
					<div className='d-flex text-start align-items-center '>
						<img src={img2} alt='icon' title='icon' />
						<div className=' ms-4'>
							<p className='weo_head mb-0'>100+ Registrations</p>
							<p className='weo_sub_head mb-0'>done every month</p>
						</div>
					</div>
				</div>
				<div className='mt-4 mt-md-5'>
					<div className='d-flex text-start align-items-center '>
						<img src={img3} alt='icon' title='icon' />
						<div className=' ms-4'>
							<p className='weo_head mb-0'>Speedy Delivery</p>
							<p className='weo_sub_head mb-0'>of services</p>
						</div>
					</div>
				</div>
				<div className='mt-4 mt-md-5'>
					<div className='d-flex text-start align-items-center '>
						<img src={img4} alt='icon' title='icon' />
						<div className=' ms-4'>
							<p className='weo_head mb-0'>Professional Services</p>
							<p className='weo_sub_head mb-0'>offered</p>
						</div>
					</div>
				</div>
			</div>
			{data?.faqs_title_active !== null && (
				<div id='faq'>
					<p className='sc_tab_head text-start my-4 '>FAQs</p>
					{data?.faqs_details_active?.map((res, i) => {
						return (
							<Accordion key={i}>
								<Accordion.Item className='mt-3  border-0' eventKey='0'>
									<Accordion.Header style={{ background: ' #e7f5f4' }}>
										Q : {res.faqs_question}
									</Accordion.Header>
									<Accordion.Body className='text-start'>
										{res.faqs_answer}
									</Accordion.Body>
								</Accordion.Item>
							</Accordion>
						);
					})}
				</div>
			)}
		</div>
	);
}

export default Tabs;
